module.exports = __webpack_public_path__ + "static/media/Page404.fc3564d2.png";